import { render, staticRenderFns } from "./UserAdminView.vue?vue&type=template&id=12733c2e&"
import script from "./UserAdminView.vue?vue&type=script&lang=js&"
export * from "./UserAdminView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports